import type {
  PostProductImpressionRequest,
  PostProductImpressionResponse,
} from '~/api/aspida/@types';
import { sendRequest } from '~/api/sendRequest';

export const postProductImpression = sendRequest<
  PostProductImpressionRequest,
  PostProductImpressionResponse
>({
  url: '/product_impression',
  method: 'post',
});
